import React from 'react';
import styles from './ThumbDescription.module.scss';
import { mergeClassNames } from '../../utils/mergeClassNames';
import ContentBuilder from '../../core/ContentBuilder';
import { Link } from './Link';

export class ThumbDescription extends React.Component<{children}>
{
	render()
	{
		return (
			<ul className={styles['list']}>
				{this.props.children}
			</ul>
		);
	}
}

export class ThumbDescriptionItem extends React.Component
{
	render()
	{
		return (
			<li className={mergeClassNames([(this.props['className'] || '').split(' '), 'item'], styles)}>
				<img src={this.props['image']} />
				<div className={styles['text-content']}>
					<div className={styles['title']}>{this.props['title']}</div>
					<div className={styles['text']}>{ContentBuilder.build(this.props['text'], {}, styles)}</div>
					{
						this.props['button']?(
							<Link className={mergeClassNames(['round', 'white', 'theme-purple', 'button'], styles)} arrow={false} decoration={false}  href={this.props['button']['href']}>{this.props['button']['label']}</Link>
						):null
					}
				</div>
			</li>
		);
	}
}